var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["createHttpClient"]: () => (__WEBPACK_EXTERNAL_MODULE__wix_http_client_948599ba__.createHttpClient) });